import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const PhotoFolderPanelSkeleton: React.FC = () => (
  <div className="space-y-2">
    <Skeleton className="h-8 w-full" />
    <Skeleton className="h-8 w-full" />
    <Skeleton className="ml-5 h-8 w-5/6" />
    <Skeleton className="ml-5 h-8 w-4/6" />
    <Skeleton className="h-8 w-full" />
  </div>
)

export default PhotoFolderPanelSkeleton
